import styled from '@emotion/styled';
import { INFO_MESSAGE_BACKGROUND_COLOR } from '@/styles';

export const CRSTaxDetailsContainer = styled.div`
  align-items: flex-start;
  background-color: ${({ theme: { themeType } }) =>
    themeType === 'ppReactTheme'
      ? 'transparent'
      : INFO_MESSAGE_BACKGROUND_COLOR};
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  margin: 24px auto;
  width: 100%;
  padding: ${({ theme: { themeType } }) =>
    themeType === 'ppReactTheme' ? '0' : '12px'};
  text-align: ${({ theme: { themeType } }) =>
    themeType === 'ppReactTheme' ? 'left' : 'initial'};
`;
